import type {
  Event,
  GroupSessionEventableList,
  GroupSessionEventableDetail,
  StaffMember,
} from "@/api/events/types";
import type { EventBlueprintStaffMember } from "@/api/gym-schedule-blueprints/types";
import { EVENTABLE_TYPE } from "@/constants/events";

const NO_STAFF_MEMBER_ID = 0;

export const resolveBlueprintStaffMember = (
  staffMember: EventBlueprintStaffMember | null,
): StaffMember =>
  staffMember
    ? { ...staffMember, avatarUrl: staffMember.avatarUrl ?? undefined }
    : { id: NO_STAFF_MEMBER_ID, name: "" };

export const hasAssignedStaffMember = (staffMember: StaffMember): boolean =>
  staffMember.id !== NO_STAFF_MEMBER_ID;

export const isGroupSessionEventableList = (
  eventable: unknown,
): eventable is GroupSessionEventableList =>
  typeof eventable === "object" &&
  eventable !== null &&
  "discipline" in eventable &&
  "gymRoom" in eventable;

export const isGroupSessionList = (
  e: Event,
): e is Extract<
  Event,
  { eventableType: typeof EVENTABLE_TYPE.GroupSession }
> & {
  eventable: GroupSessionEventableList;
} =>
  e.eventableType === EVENTABLE_TYPE.GroupSession &&
  "discipline" in e.eventable;

export const isGroupSessionDetail = (
  e: Event,
): e is Extract<
  Event,
  { eventableType: typeof EVENTABLE_TYPE.GroupSession }
> & {
  eventable: GroupSessionEventableDetail;
} =>
  e.eventableType === EVENTABLE_TYPE.GroupSession &&
  "disciplineRoom" in e.eventable;

export const isCurrentStaffAssociatedWithEvent = (
  event: Pick<Event, "eventableType" | "eventable">,
  currentStaffId: number | null | undefined,
): boolean => {
  if (currentStaffId == null) return false;
  if (
    event.eventableType !== EVENTABLE_TYPE.GroupSession &&
    event.eventableType !== EVENTABLE_TYPE.FloorDuty
  ) {
    return false;
  }
  return event.eventable?.staffMember?.id === currentStaffId;
};
